import {
  FETCH_FLOWCHARTS,
  FETCH_FLOWCHARTS_REQUEST,
  CREATE_FLOWCHART,
  UPDATE_FLOWCHART,
  SELECT_FLOWCHART,
  SET_ERROR,
  GENERATED_FLOWCHART_SUCCESS,
  GENERATED_FLOWCHART_FAILURE,
  GENERATED_FLOWCHART_START,
  DELETE_FLOWCHART,
  GET_FLOWCHART_BY_ID,
  FETCH_FLOWCHARTS_NEW,
  CREATEORUPDATE_FLOWCHART,
  FETCH_WORKFLOW_PAGES,
  ADD_WORKFLOW_PAGE,
  DELETE_WORKFLOW_PAGE,
  UPDATE_WORKFLOW_PAGE,
  RENAME_FLOWCHART,
} from '../actions/flowchartActions';

const initialState = {
  flowcharts: [],
  flowchartsScopeKey: null,
  currentFlowchart: null,
  loading: false,
  error: null,
  risks: [],
  assets: [],
  partialNodes : [],
  partialEdges : [],
  pages: [],
};

const flowchartReducer = (state = initialState, action) => {
  // ////console.log('flowchartReducer - Action received:', action.type);
  // ////console.log('flowchartReducer - Current state risks:', state.risks);
  // ////console.log('flowchartReducer - Action risks:', action.risks);
  
  switch (action.type) {
    case FETCH_FLOWCHARTS_REQUEST: {
      const isScopeChange =
        action.scopeKey != null && action.scopeKey !== state.flowchartsScopeKey;
      return {
        ...state,
        flowcharts: isScopeChange ? [] : state.flowcharts,
        flowchartsScopeKey: action.scopeKey ?? state.flowchartsScopeKey,
        loading: true,
        error: null,
      };
    }

    case FETCH_FLOWCHARTS:
      if (
        action.scopeKey != null &&
        state.flowchartsScopeKey != null &&
        action.scopeKey !== state.flowchartsScopeKey
      ) {
        return state;
      }
      return {
        ...state,
        flowcharts: action.payload,
        flowchartsScopeKey: action.scopeKey ?? state.flowchartsScopeKey,
        loading: false,
        error: null
      };

    case CREATEORUPDATE_FLOWCHART:
      ////console.log('Creating or updating flowchart:', action.payload);
      return {
        ...state,
        flowcharts: action.payload,
        currentFlowchart: action.payload,
        risks: action.risks,
        assets: action.assets,
        error: null
      };
      

    case FETCH_FLOWCHARTS_NEW:
      ////console.log('Setting flowcharts:', action.payload);
      return {
        ...state,
        flowcharts: action.payload,
        risks: action.risks,
        assets: action.assets,
        loading: false,
        error: null
      };
    
    case CREATE_FLOWCHART:
      ////console.log('Creating flowchart:', action.payload);
      return {
        ...state,
        flowcharts: [...state.flowcharts, action.payload],
        currentFlowchart: action.payload,
        error: null
      };
    
    case UPDATE_FLOWCHART:
      ////console.log('Updating flowchart:', action.payload);
      const updatedFlowcharts = state.flowcharts.map(flowchart =>
        flowchart.id === action.payload.id
          ? { ...flowchart, partialNodes: action.payload.partialNodes, partialEdges: action.payload.partialEdges }
          : flowchart
      );
      return {
        ...state,
        flowcharts: updatedFlowcharts,
        currentFlowchart: state.currentFlowchart?.id === action.payload.id
          ? { ...state.currentFlowchart, partialNodes: action.payload.partialNodes, partialEdges: action.payload.partialEdges }
          : state.currentFlowchart,
        error: null
      };
    
    case SELECT_FLOWCHART:
      ////console.log('Selecting flowchart:', action.payload);
      return {
        ...state,
        currentFlowchart: action.payload,
        error: null
      };

    case SET_ERROR:
      ////console.log('Setting error:', action.payload);
      return {
        ...state,
        error: action.payload
      };

    case GENERATED_FLOWCHART_START:
      return {
        ...state,
        loading: true,
        error: null,
        partialNodes:[],
        partialEdges: [],
      };

    case "GENERATED_FLOWCHART_PARTIAL": {
        // we trust the thunk to send *complete* arrays in action.payload
        ////console.log("PARTIAL PAYLOAD", action.payload)
        const { partialNodes, partialEdges } = action.payload;
        return { ...state, partialNodes, partialEdges };
    }

    case GENERATED_FLOWCHART_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null
      };

    case GENERATED_FLOWCHART_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false
      };

    case RENAME_FLOWCHART:
      return {
        ...state,
        flowcharts: state.flowcharts.map(f =>
          f.id === action.payload.id ? { ...f, name: action.payload.name } : f
        ),
        currentFlowchart: state.currentFlowchart?.id === action.payload.id
          ? { ...state.currentFlowchart, name: action.payload.name }
          : state.currentFlowchart,
      };

    case DELETE_FLOWCHART:
      return {
        ...state,
        flowcharts: state.flowcharts.filter(flowchart => flowchart.id !== action.payload),
        currentFlowchart: state.currentFlowchart?.id === action.payload ? null : state.currentFlowchart,
        error: null
      };

    case GET_FLOWCHART_BY_ID:
      ////console.log('flowchartReducer - Handling GET_FLOWCHART_BY_ID');
      ////console.log('flowchartReducer - Payload:', action.payload);
      ////console.log('flowchartReducer - Risks:', action.risks);
      ////console.log('flowchartReducer - Assets:', action.assets);
      
      // Clear any existing risks before setting new ones
      const newState = {
        ...state,
        currentFlowchart: action.payload,
        risks: action.risks || [],
        assets: action.assets || [],
        loading: false,
        error: null
      };
      
      ////console.log('flowchartReducer - New state:', newState);
      return newState;

    case 'SET_FLOWCHARTS':
      // Clear risks when setting new flowcharts
      return {
        ...state,
        flowcharts: action.payload,
        risks: [],
        assets: []
      };
    
    case 'RISK':
      // Handle risk data updates
      return {
        ...state,
        risks: action.risk ? [action.risk] : state.risks
      };

    case 'CLEAR_PARTIAL_FLOWCHART':
      return {
        ...state,
        partialNodes: [],
        partialEdges: [],
      };

    case FETCH_WORKFLOW_PAGES:
      return {
        ...state,
        pages: action.payload || []
      };

    case ADD_WORKFLOW_PAGE: {
      const newPage = action.payload?.page || action.payload;
      if (!newPage?.page_id) return state;
      return { ...state, pages: [...state.pages, newPage] };
    }

    case DELETE_WORKFLOW_PAGE:
      return {
        ...state,
        pages: state.pages.filter(p => p.page_id !== action.payload)
      };

    case UPDATE_WORKFLOW_PAGE:
      return {
        ...state,
        pages: state.pages.map(p =>
          p.page_id === action.payload.page_id ? { ...p, ...action.payload } : p
        )
      };

    default:
      return state;
  }
};

export default flowchartReducer; 